import React from 'react';

export function Tabs({ children, value, onValueChange, ...props }) {
  return (
    <div {...props}>
      {React.Children.map(children, child => {
        if (child?.type === TabsList || child?.type === TabsContent) {
          return React.cloneElement(child, { value, onValueChange });
        }
        return child;
      })}
    </div>
  );
}

export function TabsList({ children, className = "", value, onValueChange, ...props }) {
  return (
    <div className={`inline-flex h-10 items-center justify-center rounded-md bg-gray-100 p-1 ${className}`} {...props}>
      {React.Children.map(children, child => {
        if (child?.type === TabsTrigger) {
          return React.cloneElement(child, { 
            isActive: value === child.props.value,
            onClick: () => onValueChange(child.props.value)
          });
        }
        return child;
      })}
    </div>
  );
}

export function TabsTrigger({ children, className = "", value, isActive, onClick, ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ${
        isActive ? 'bg-white shadow-sm' : 'hover:bg-gray-50'
      } ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export function TabsContent({ children, value, ...props }) {
  return <div {...props}>{children}</div>;
}